import React from "react";

const Button = ({
  children,
  variant = "primary",
  fullWidth = false,
  onClick,
}) => {
  const classes = `btn btn-${variant} ${fullWidth ? "btn-full" : ""}`;

  return (
    <button className={classes} onClick={onClick}>
      {children}
    </button>
  );
};

export default Button;
